import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%'
  },
  walletTypeSelection: {
    marginTop: 10,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  walletTypeButton: {
    padding: theme.spacing(1, 3),
    textTransform: 'none',
    fontSize: '1rem',
    borderRadius: '20px', // Rounded corners for pill shape
    position: 'relative', // Necessary for positioning the dot
    backgroundColor: theme.palette.grey[200], // Gray background when not selected
    color: theme.palette.text.primary,
    border: 'none', // No border for unselected
    '&:hover': {
      backgroundColor: theme.palette.grey[300]
    }
  },
  walletTypeButtonSelected: {
    backgroundColor: theme.palette.background.paper, // Light background for selected
    border: '1px solid black', // Black border for selected
    color: theme.palette.text.primary,
    fontWeight: 500, // Make text bold
    borderRadius: 4
  },
  walletTypeButtonNotSelected: {
    backgroundColor: theme.palette.background.paper, // Light background for selected
    color: theme.palette.text.primary,
    fontWeight: 500, // Make text bold
    borderRadius: 4
  },
  dotIndicator: {
    width: 7,
    height: 7,
    backgroundColor: theme.palette.text.primary,
    borderRadius: '50%',
    position: 'absolute',
    top: 8, // Position it near the top-right
    right: 8
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

export default useStyles
